var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1303.4 1029.7" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0",
        y: "0",
        viewBox: "0 0 1303.4 1029.7",
        "xml:space": "preserve",
      },
    },
    [
      _c(
        "g",
        { attrs: { transform: "matrix(1.96098 0 0 1.95714 1100 269)" } },
        [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_1_", d: "M-232.1-254.5h402v685h-402z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_2_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_1_" },
            }),
          ]),
          _c(
            "g",
            { staticStyle: { "clip-path": "url(#SVGID_2_)" } },
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_3_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-369.764",
                    y1: "-706.62",
                    x2: "324.602",
                    y2: "-706.62",
                    gradientTransform:
                      "matrix(.282 0 0 -.2814 -29.358 -110.315)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#94ddfb" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#64bdf2" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_3_)" },
                attrs: {
                  d: "M-34.7-27.5c.2-.3.5-.6.7-.9h-.5c2.4-9.7-2.3-20.1-8.9-27.7-2.9-3.4-6.4-6.5-10.6-7.8-4.4-1.4-9.3-.7-13.8.4C-80.9-60.1-93-52.9-102.3-43c-3 3.2-5.9 7.4-5.1 11.7 1 4.8 6.4 9.2 4.2 13.6-2.3 4.5-10.1 2.9-13 7.1-4.3 6.5 9.1 14.3 5.7 21.4-1.8 3.6-6.6 3.9-10.3 5.5-7 3.1-9.9 13.1-5.5 19.5 3.9 5.6 12.6 9.6 11 16.3-.6 2.3-2.4 4.1-4.1 5.8-5.5 5.6-10.4 12.2-12.7 19.7-2.4 7.5-2 16.2 2.2 22.8 2.2 3.4 5.2 6.1 8.4 8.7 15.6 12.7 21.6 26.1 34.2 41.9 7.8 9.9 25.2 73.1 29.5 90.8C-54.6 215.9-47.1 139-44 134.7c3.1-4.3 4.7-10.3 2.1-14.8-1.9-3.3-5.6-5.1-8.8-7.4-3.1-2.2-6.1-5.7-5.4-9.5.3-1.7 1.5-3.2 2.6-4.6C-50 94-45.9 90-43.3 84.9c2.6-5 3.3-11.5 0-16.1-3.1-4.3-9.1-6.2-13.8-8.8 4-3.1 9.9-5.2 13.2-9.1 2.5-3 3.5-7.3 2.4-11.1-1.1-4-4.2-7.1-6.6-10.5.5-2 .4-4-.8-5.8-.6-1-1.5-1.7-2.4-2.3-.1-2 .3-3.9 1.7-5.5 2-2.3 5.5-3 7.7-5.1C-38.3 7.2-39.5.3-44-1.7c-2.6-1.1-6.4-1.4-6.8-4.2v-1c6.6-6.3 13.7-12.1 16.1-20.6z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_4_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-144.589",
                    y1: "-785.471",
                    x2: "397.522",
                    y2: "-785.471",
                    gradientTransform:
                      "matrix(.282 0 0 -.2814 -29.358 -110.315)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#b9f4fc" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#c4fbfc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_4_)" },
                attrs: {
                  d: "M0 120.7c-1.8-4.6-6.1-8.2-7-13.1-1.2-7.1 5-13 9-19 6.1-9.1 7.5-21.1 3.6-31.3S-7.1 39-17.6 36.2c-6.7-1.8-14.1-1.6-20-5.1-8.1-4.8-14.6-16.4-23.5-13.3-6.2 2.2-7.7 10.7-5.6 17s6.4 11.6 8.4 17.9c3.7 12.1-2.2 24.7-6.9 36.4s-7.9 26.2-.1 36.1c3.8 4.8 9.9 8 12.1 13.7 3 7.8-2.5 16-5.2 23.9-5 14.7.7 32.5 13.4 41.5.4-18.8 9.2-37.2 23.4-49.4 5.5-4.7 11.8-8.6 16.6-14.1 4.7-5.5 7.7-13.3 5-20.1z",
                },
              }),
              _c("path", {
                staticClass: "st3",
                attrs: {
                  d: "M-65.1 232.8h-.1c-.5-.1-.8-.5-.7-1 4.1-28.8 10.1-55.9 18.1-80.4.1-.4.6-.7 1.1-.5.4.1.7.6.5 1.1-8 24.4-14 51.4-18.1 80.1 0 .4-.4.7-.8.7z",
                },
              }),
              _c("path", {
                staticClass: "st4",
                attrs: {
                  d: "M-57 140c2.4-3.6 9.1-3.3 14.9.6 5.8 3.9 8.5 10 6.1 13.6-2.4 3.6-9.1 3.3-14.9-.6-5.8-3.9-8.5-10-6.1-13.6z",
                },
              }),
              _c("path", {
                staticClass: "st3",
                attrs: {
                  d: "M-45.2 147.2h-.3c-.4-.2-.7-.6-.5-1.1 4.1-12 8.8-23.7 13.8-34.6.2-.4.7-.6 1.1-.4.4.2.6.7.4 1.1-5.1 10.9-9.7 22.5-13.8 34.5 0 .2-.3.5-.7.5z",
                },
              }),
              _c("path", {
                staticClass: "st4",
                attrs: {
                  d: "M-45.1 96.6c2.4-3.6 11.5-1.7 20.2 4.2s13.8 13.7 11.4 17.3c-2.4 3.6-11.5 1.7-20.2-4.2-8.7-6-13.8-13.7-11.4-17.3z",
                },
              }),
              _c("path", {
                staticClass: "st3",
                attrs: {
                  d: "M-29.6 108.8c-.1 0-.2 0-.4-.1-.4-.2-.6-.7-.4-1.1 1.5-3.2 3.1-6.4 4.8-9.5 4.4-8.6 9.3-16.9 14.4-24.9.3-.4.8-.5 1.2-.3.4.3.5.8.3 1.2-5.1 7.9-10 16.3-14.4 24.8-1.6 3.1-3.2 6.3-4.7 9.5-.2.2-.5.4-.8.4z",
                },
              }),
              _c("path", {
                staticClass: "st4",
                attrs: {
                  d: "M-24.8 54.6c2.9-2.9 12 1.6 20.4 10s12.8 17.6 10 20.5c-2.9 2.9-12-1.6-20.4-10s-12.9-17.7-10-20.5z",
                },
              }),
              _c("path", {
                staticClass: "st3",
                attrs: {
                  d: "M-7.8 70.4c-.2 0-.3 0-.5-.1-.3-.3-.4-.9-.2-1.3 6.9-10.3 14.4-20.1 22.3-29.1.3-.4.8-.4 1.2-.1.4.3.4.8.1 1.2C7.3 50-.2 59.7-7.1 70c-.1.2-.4.4-.7.4z",
                },
              }),
              _c("path", {
                staticClass: "st4",
                attrs: {
                  d: "M6.3 10.7c5.1-2.2 14.5 8 20.9 22.9 6.5 14.9 7.6 28.7 2.5 31-5.1 2.2-14.5-8-20.9-22.9s-7.6-28.8-2.5-31z",
                },
              }),
              _c("path", {
                staticClass: "st3",
                attrs: {
                  d: "M18.7 36.7c-.2 0-.4-.1-.6-.2-.3-.3-.4-.9 0-1.2C26.3 26.5 35 18.2 44 10.9c.4-.3.9-.2 1.2.1.3.4.2.9-.1 1.2-9 7.3-17.6 15.4-25.7 24.2-.3.2-.5.3-.7.3z",
                },
              }),
              _c("path", {
                staticClass: "st4",
                attrs: {
                  d: "M26.5-18.2C30.8-21.8 44-12.9 56 1.7c12 14.6 18.3 29.2 14 32.8-4.3 3.5-17.5-5.4-29.5-19.9s-18.2-29.3-14-32.8z",
                },
              }),
              _c("path", {
                staticClass: "st3",
                attrs: {
                  d: "M49 8.8c-.3 0-.5-.1-.7-.3-.3-.4-.2-.9.2-1.2 6-4.6 12.1-8.9 18.4-12.8.4-.2.9-.1 1.2.3.2.4.1.9-.3 1.2C61.6-.2 55.4 4.1 49.5 8.6c-.2.2-.3.2-.5.2z",
                },
              }),
              _c("path", {
                staticClass: "st5",
                attrs: {
                  d: "m-50 249.1-3.1-9.4c-.1-.4.1-.9.5-1.1.1 0 .2-.1.3 0-2-45.3-3.1-98.5 2.9-152.5.3-2.6.6-5.2.9-7.7.1-.5.5-.8.9-.7.5.1.8.5.7 1-.3 2.5-.6 5.1-.9 7.7-6.2 55.7-4.8 110.4-2.7 156.6l.5 6.1z",
                },
              }),
              _c("path", {
                staticClass: "st3",
                attrs: {
                  d: "M-58.9 78.8c-.6-2.3 3.9-5.6 10-7.3s11.7-1.2 12.4 1.1-3.9 5.6-10 7.3c-6.2 1.7-11.8 1.2-12.4-1.1z",
                },
              }),
              _c("path", {
                staticClass: "st5",
                attrs: {
                  d: "M-47.1 75.7h-.1c-.5-.1-.8-.5-.7-1 2.1-15.8 4.7-31.3 8-46 .1-.5.6-.8 1-.7.5.1.7.6.6 1-3.2 14.7-5.9 30.1-7.9 45.9-.1.5-.4.8-.9.8z",
                },
              }),
              _c("path", {
                staticClass: "st3",
                attrs: {
                  d: "M-53.8 30.2c-.6-2.3 5.2-6 13-8.1s14.7-2 15.3.3c.6 2.3-5.2 6-13 8.1s-14.7 2.1-15.3-.3z",
                },
              }),
              _c("path", {
                staticClass: "st5",
                attrs: {
                  d: "M-38.3 26.1h-.2c-.5-.1-.7-.6-.6-1 3-13.4 6.6-26.5 10.6-39 .1-.4.6-.7 1.1-.6.4.1.7.6.6 1.1-4 12.4-7.5 25.5-10.6 38.9-.2.3-.5.6-.9.6z",
                },
              }),
              _c("ellipse", {
                staticClass: "st3",
                attrs: {
                  transform:
                    "matrix(.08578 -.9963 .9963 .08578 -8.573 -43.411)",
                  cx: "-27.9",
                  cy: "-17",
                  rx: "6.9",
                  ry: "18.5",
                },
              }),
              _c("path", {
                staticClass: "st5",
                attrs: {
                  d: "M-26.1-17.7h-.3c-.4-.1-.7-.6-.5-1.1 3-8.9 6.2-17.7 9.7-26.2.2-.4.7-.6 1.1-.5.4.2.6.7.5 1.1-3.5 8.4-6.7 17.2-9.7 26-.2.5-.5.7-.8.7z",
                },
              }),
              _c("path", {
                staticClass: "st3",
                attrs: {
                  d: "M-34.8-51.4c.5-3.5 9.5-4.9 20.1-3.2s18.6 5.8 18.1 9.3c-.5 3.5-9.5 4.9-20.1 3.2-10.5-1.7-18.6-5.9-18.1-9.3z",
                },
              }),
              _c("path", {
                staticClass: "st5",
                attrs: {
                  d: "M-14.7-48c-.1 0-.2 0-.3-.1-.4-.2-.6-.7-.4-1.1 2.3-5.3 4.7-10.6 7.1-15.7.7-1.5 1.5-3.1 2.3-4.6.2-.4.7-.6 1.1-.4.4.2.6.7.4 1.1-.8 1.5-1.5 3.1-2.3 4.6-2.4 5.1-4.8 10.3-7.1 15.6-.2.5-.5.6-.8.6z",
                },
              }),
              _c("path", {
                staticClass: "st3",
                attrs: {
                  d: "M-26.9-76.4c.7-4.2 10.9-6 23-4.1s21.2 6.9 20.6 11c-.7 4.2-10.9 6-23 4.1-12-1.9-21.2-6.8-20.6-11z",
                },
              }),
              _c("path", {
                staticClass: "st5",
                attrs: {
                  d: "M-2.4-74c-.1 0-.3 0-.4-.1-.4-.2-.6-.7-.4-1.2C-1.2-79.1.9-83 3-86.6c.2-.4.8-.5 1.2-.3.4.2.5.8.3 1.2-2.1 3.6-4.2 7.4-6.2 11.3-.1.2-.4.4-.7.4z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_5_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-212.074",
                    y1: "-1176.628",
                    x2: "251.605",
                    y2: "-1176.628",
                    gradientTransform:
                      "matrix(.282 0 0 -.2814 -29.358 -110.315)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#c9f8ec" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#b1e1d6" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_5_)" },
                attrs: { d: "M-89.2 178.7h66.7V263h-66.7z" },
              }),
            ],
            1
          ),
        ]
      ),
      _c("g", { attrs: { transform: "matrix(3.01333 0 0 3.01818 386 460)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_6_", d: "M-389-222.9h904v498h-904z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_7_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_6_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_7_)" } },
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_8_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-81.402",
                  y1: "-140.917",
                  x2: "555.583",
                  y2: "-140.917",
                  gradientTransform:
                    "matrix(1.2053 0 0 -1.2073 33.759 -144.037)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#81d2f2" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#78cdef" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_8_)" },
              attrs: { d: "M-64.4-56.4h254.8v165H-64.4z" },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: { d: "M-58.2-43.6h242.5V83.5H-58.2z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_9_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "18.741",
                  y1: "-144.964",
                  x2: "300.736",
                  y2: "-144.964",
                  gradientTransform:
                    "matrix(1.2053 0 0 -1.2073 33.759 -144.037)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#defffe" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_9_)" },
              attrs: {
                d: "M169.1 58.6H56.3V17.9c0-8 6.5-14.5 14.6-14.5h98.2v55.2zM57.9 57h109.7V4.9H70.9c-7.2 0-13 5.8-13 13V57z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_10_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-10.204",
                  y1: "-158.751",
                  x2: "271.791",
                  y2: "-158.751",
                  gradientTransform:
                    "matrix(1.2053 0 0 -1.2073 33.759 -144.037)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#defffe" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_10_)" },
              attrs: {
                d: "M134.3 75.2H21.5V34.5C21.5 26.5 28 20 36 20h98.2l.1 55.2zM23 73.7h109.7V21.6H36c-7.2 0-13 5.8-13 13v39.1z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_11_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-64.564",
                  y1: "-103.148",
                  x2: "474.931",
                  y2: "-103.148",
                  gradientTransform:
                    "matrix(1.2053 0 0 -1.2073 33.759 -144.037)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#defffe" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_11_)" },
              attrs: {
                d: "M171.7-7H-44.1v-13.6c0-6.3 5.1-11.3 11.4-11.3h204.4V-7z",
              },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: { d: "M-87 97.3h300v11.3H-87z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_12_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-35.373",
                  y1: "-101.869",
                  x2: "-1.981",
                  y2: "-101.869",
                  gradientTransform:
                    "matrix(1.2053 0 0 -1.2073 33.759 -144.037)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#78cdef" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_12_)" },
              attrs: { d: "M-8.9-27.7H4.5v13.3H-8.9z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_13_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "33.062",
                  y1: "-140.927",
                  x2: "66.454",
                  y2: "-140.927",
                  gradientTransform:
                    "matrix(1.2053 0 0 -1.2073 33.759 -144.037)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#78cdef" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_13_)" },
              attrs: { d: "M73.6 19.4H87v13.3H73.6z" },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: { d: "M-8.6-25.9h3.7v3.6h-3.7z" },
            }),
            _c("path", {
              staticClass: "st5",
              attrs: { d: "M170.9 72.2h3.7v3.6h-3.7z" },
            }),
            _c("path", {
              staticStyle: { fill: "#f6f6f6" },
              attrs: { d: "M66.6 88.5h3.7v3.6h-3.7z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_14_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-28.596",
                  y1: "-116.213",
                  x2: "-2.863",
                  y2: "-116.213",
                  gradientTransform:
                    "matrix(1.2053 0 0 -1.2073 33.759 -144.037)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#78cdef" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_14_)" },
              attrs: { d: "M-.7-8.9H9.6V1.4H-.7z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_15_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "70.343",
                  y1: "-105.492",
                  x2: "96.075",
                  y2: "-105.492",
                  gradientTransform:
                    "matrix(1.2053 0 0 -1.2073 33.759 -144.037)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#78cdef" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_15_)" },
              attrs: { d: "M118.5-21.8h10.3v10.3h-10.3z" },
            }),
            _c("path", {
              staticClass: "st5",
              attrs: { d: "M99.7 1.6H110v10.3H99.7z" },
            }),
            _c("path", {
              staticClass: "st18",
              attrs: { d: "M-16.3.1h7.2v7.2h-7.2z" },
            }),
            _c("path", {
              staticClass: "st5",
              attrs: { d: "M48.1 13.8h7.2V21h-7.2z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_16_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-26.901",
                  y1: "-134.183",
                  x2: "-11.381",
                  y2: "-134.183",
                  gradientTransform:
                    "matrix(1.2053 0 0 -1.2073 33.759 -144.037)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#78cdef" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_16_)" },
              attrs: { d: "M1.3 14.9h6.2v6.2H1.3z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_17_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-26.901",
                  y1: "-167.938",
                  x2: "-11.381",
                  y2: "-167.938",
                  gradientTransform:
                    "matrix(1.2053 0 0 -1.2073 33.759 -144.037)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#78cdef" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_17_)" },
              attrs: { d: "M1.3 55.6h6.2v6.2H1.3z" },
            }),
            _c("path", {
              staticClass: "st21",
              attrs: {
                d: "M-58.2 99.4h28.8v7.2h-28.8zM-19.2 99.4H.7v7.2h-19.9z",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "g",
        { attrs: { transform: "matrix(-1.97442 0 0 1.94827 791 787)" } },
        [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_18_", d: "M82.1-109.8h205v94h-205z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_19_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_18_" },
            }),
          ]),
          _c(
            "g",
            {
              staticStyle: { "clip-path": "url(#SVGID_19_)" },
              attrs: { transform: "translate(343.543 -748.354)" },
            },
            [
              _c("path", {
                staticClass: "st3",
                attrs: { d: "M-153.8 709.7h46.8v-6.8h-46.8z" },
              }),
              _c("path", {
                staticStyle: { fill: "#3b3873" },
                attrs: { d: "M-210.8 661.5h58.1l13.4 48.2h-58.1z" },
              }),
              _c("ellipse", {
                staticClass: "st3",
                attrs: { cx: "-176.8", cy: "686.4", rx: "9.9", ry: "9.7" },
              }),
            ]
          ),
        ]
      ),
      _c("g", { attrs: { transform: "matrix(1.196 0 0 1.2 374 625)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_20_", d: "M-243.6-181.9h299v480h-299z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_21_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_20_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_21_)" } },
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_hand_1_-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-6620.457",
                  y1: "1490.653",
                  x2: "-5465.14",
                  y2: "1490.653",
                  gradientTransform:
                    "matrix(-.08862 0 0 .08892 -573.604 -94.12)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_hand_1_-i2_1_)" },
              attrs: {
                id: "L_hand_1_-i2",
                d: "M-58.5 28.8s17.4 3.2 26.6-.1C-22.7 25.5-9.5 17-5 20.1c4.5 3.1 18.1 12.7 18.1 12.7S9.3 37 1 31.8s-9.5-1.8-14 1.5-13.4 12.7-21.5 9.9c-8.1-2.8-12.5-1.9-19.8 3-7.3 4.9-18.2 11.3-18.2 11.3l6.2-24.5 7.8-4.2z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "R_sleeve_1_-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-5812.286",
                  y1: "-2498.23",
                  x2: "-4906.388",
                  y2: "-2498.23",
                  gradientTransform:
                    "matrix(-.08862 0 0 -.08892 -573.604 -207.5)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#28306d" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#13194c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#R_sleeve_1_-i2_1_)" },
              attrs: {
                id: "R_sleeve_1_-i2",
                d: "M-125.6-11.4c.3 1.3.6 2.7.9 4.2 5.9 32.3 20 46.1 38.7 47.7 10.1.9 18.7-.6 25.7-1.4l1.8-10.2c-52.7-4-62.6-30.5-67.1-40.3z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_shoe-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "6058.799",
                  y1: "-4992.642",
                  x2: "5186.516",
                  y2: "-5111.589",
                  gradientTransform:
                    "matrix(.08862 0 0 -.08892 -524.44 -207.5)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#81d2f2" },
                  attrs: { offset: ".696" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#7dd0f1" },
                  attrs: { offset: ".844" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#78cdef" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_shoe-i2_1_)" },
              attrs: {
                id: "L_shoe-i2",
                d: "m-53.3 222.1-12.9 36.1h91.1s-4.7-9-20.2-15.7c-15.6-6.7-30.1-20.3-30.1-20.3l-27.9-.1",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "R_shoe-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "5136.073",
                  y1: "-5036.766",
                  x2: "3520.37",
                  y2: "-5314.31",
                  gradientTransform:
                    "matrix(.08862 0 0 -.08892 -524.44 -207.5)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#81d2f2" },
                  attrs: { offset: ".696" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#78cdef" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#R_shoe-i2_1_)" },
              attrs: {
                id: "R_shoe-i2",
                d: "m-106.7 222.1-12.9 36.1h91.1s-4.7-9-20.2-15.7c-15.6-6.7-28.2-20.4-28.2-20.4h-29.8",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_trousers-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "6512.936",
                  y1: "-4718.242",
                  x2: "4822.119",
                  y2: "-3424.511",
                  gradientTransform:
                    "matrix(.08862 0 0 -.08892 -524.44 -207.5)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#1A7BEE" },
                  attrs: { offset: ".129" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#0088b6" },
                  attrs: { offset: ".999" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_trousers-i2_1_)" },
              attrs: {
                id: "L_trousers-i2",
                d: "M-55.3 58.2c-26.9-2.8-69.6-4.1-69.6-4.1l-63 11s-13 29 38.6 31.7c24.6 1.3 77.1 11.8 89.7 6.5 2.3-1 5 .1 6 2.4.3.6.4 1.3.4 2-.3 5-.3 7.5-7.3 26.6-10.6 29-3.6 68.3 7.2 87.8h27.9C-24 214.1-6.5 106.8-6 89.5c.9-27.2-30.3-29.4-49.3-31.3z",
              },
            }),
            _c("path", {
              staticClass: "st5",
              attrs: {
                id: "R_trousers-i2",
                d: "M-203.6 43.1s-21 47.8 28.7 61.8c23.7 6.7 74.5 6.3 88 3.9 2.5-.4 4.9 1.2 5.3 3.7.1.7.1 1.4-.1 2-1.4 4.8-1.9 7.3-13 24.3-19 29.2-22.2 61.1-12 83.2H-77s42.8-101.6 49.5-118.4c9.4-23.8-11.2-35-37.7-40.5s-74.4-16.9-74.4-16.9l-64-3.1",
              },
            }),
            _c("path", {
              staticStyle: {
                opacity: ".86",
                fill: "#fff",
                "enable-background": "new",
              },
              attrs: {
                id: "texture-3-i2",
                d: "M-175 75c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1 0 .1 0 .2.1.3zm1.9-4.4c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.2.1-.2.1-.1.2 0 .3zm18.1 4.3c0 .1.2.2.3.1.1 0 .1-.1.1-.2s-.1-.2-.2-.1c-.2 0-.2.1-.2.2zm-26.8-7.7c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0-.1.1-.1.3 0 .3zm16.7 7.1c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm-35.9 1.8c.1.2.4.2.5 0 .2-.1.2-.4 0-.5-.1-.2-.4-.2-.5 0-.1.2-.1.4 0 .5zm6.9-5.9c.1.2.4.2.5 0 .2-.1.2-.4 0-.5-.1-.2-.4-.2-.5 0-.1.1-.2.4 0 .5zm20.3 28.6c0 .2.1.4.4.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.4-.4-.2 0-.4.1-.4.3zm.6-9c0 .2.1.4.4.4.2 0 .4-.1.4-.4 0-.2-.1-.4-.3-.4-.3 0-.5.2-.5.4zm.7-9c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.4-.4-.2-.1-.3.1-.3.3zm.6-9.1c0 .2.1.4.4.4.2 0 .4-.1.4-.4 0-.2-.1-.4-.3-.4-.3.1-.5.2-.5.4zm-33.2-11.1c.1.2.3.3.5.2s.3-.3.2-.5c-.1-.2-.3-.3-.5-.2-.1 0-.2.3-.2.5 0-.1 0 0 0 0zM-191 90c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2-.1.2 0 .4.2.5zm4-8.1c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2 0 .2.1.4.2.5zm4.1-8.1c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2-.1.2 0 .4.2.5zm26.2 18.7c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.2-.3-.4-.3-.3.2-.4.4-.3.6zm-2.9-8.6c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.1.1-.2.3-.2.5zm-2.8-8.6c.1.2.3.3.4.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.1.1-.2.3-.1.5zm-36.4 10.5c.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5zm4.3-6.8c.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1-.2.1-.1.3.1.5-.1-.1-.1-.1 0 0zm4.1-7.1c0 .1.1.2.1.2.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.1-.1-.2-.1-.3 0-.1 0-.1.1-.1.1-.1.1-.1.2-.1.3zm4.4-6.7c.2.1.4 0 .5-.1.1-.2 0-.4-.1-.5-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5zm20.5 26c0 .2.2.3.4.3s.3-.2.2-.4c0-.2-.2-.3-.4-.3-.1 0-.2.2-.2.4zm-1.8-7.9c0 .2.2.3.4.2.2 0 .3-.2.2-.4 0-.2-.2-.3-.4-.3-.1.2-.2.4-.2.5zm-1.8-7.8c0 .2.2.3.4.3s.3-.2.2-.4c0-.2-.2-.3-.4-.3-.1 0-.2.2-.2.4zm-33.1-9c.1.1.3.2.5.1.1-.1.2-.3.1-.4-.1-.2-.3-.2-.5-.1-.2 0-.2.2-.1.4zm6.6-4.7c.1.1.3.2.5.1s.2-.3.1-.5c-.1-.1-.3-.2-.5-.1s-.2.3-.1.5zm12.8 25.7c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.3.1-.4.3zm1.4-8c0 .2.1.3.2.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.1 0-.3.2-.3.3zm1.3-7.9c0 .2.1.4.3.4.2 0 .3-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3zm27.5 9.5c.1.1.3.2.4.1.2-.1.2-.3.1-.5-.1-.1-.3-.2-.5-.1-.1.1-.1.3 0 .5 0-.1 0 0 0 0zm-4.7-6.6c.1.2.3.2.5.1.1-.1.2-.3.1-.5-.1-.1-.3-.2-.5-.1-.1.1-.2.3-.1.5zm-41-8.7c.1.1.2.1.3 0s.1-.2 0-.3c-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3zm3.2-3.5c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0v.3zm15.5 10.4c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm-.2-4.8c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm-9 .8c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.2s-.2 0-.2.1c-.2.1-.1.2 0 .2zm1.6-4.4c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1 0 .1 0 .2.1.3zm-14.5 6.2c.1.1.2 0 .3-.1.1-.1 0-.2-.1-.3-.1-.1-.2 0-.3.1 0 .1 0 .2.1.3zm2.9-4.6c.1.1.2 0 .3-.1.1-.1 0-.2-.1-.3-.1-.1-.2 0-.3.1 0 .1 0 .2.1.3zm3-4.6c.1.1.2 0 .3 0 .1-.1 0-.2-.1-.3-.1-.1-.2 0-.3.1-.1 0-.1.2.1.2zm16.5 13.1c0 .1.1.2.2.2s.2-.1.2-.3c0-.1-.1-.2-.3-.2 0 0-.1.2-.1.3zm-1.2-5.3c0 .1.2.2.3.2.1 0 .2-.1.2-.3 0-.1-.1-.2-.3-.2-.1 0-.2.2-.2.3zm-22.9-11.7c.1.1.2.1.3.1.1-.1.1-.2.1-.3-.1-.1-.2-.1-.3 0-.2-.1-.2.1-.1.2zm13 14.5s.1 0 0 0c.2.1.3 0 .3-.1s-.1-.2-.2-.3c-.1 0-.2.1-.3.2.1.1.1.2.2.2zm.9-5.6c0 .1 0 .2.2.3.1 0 .2-.1.3-.2 0-.1-.1-.2-.2-.3-.2 0-.3.1-.3.2zm-8 18.9c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2-.1-.4.1-.4.3zm1.4-9.3c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3zm1.5-9.2c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3zm33.8 18.8c.1.2.4.2.6.1.2-.1.2-.4.1-.5-.1-.2-.4-.2-.5-.1-.3 0-.3.3-.2.5zm-5.5-7.6c.1.2.4.2.5.1.2-.1.2-.4.1-.5-.1-.2-.4-.2-.5-.1-.2.1-.2.3-.1.5zm-39.7-9.8c.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1-.1.1 0 .4.1.5zm4.9-8c.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5zm20.4 29.5c.1.2.3.3.5.3.2-.1.3-.3.3-.5s-.2-.3-.5-.3c-.2.1-.3.3-.3.5zm-2.2-9.1c.1.2.3.3.5.3.2-.1.3-.3.3-.5s-.3-.3-.5-.3c-.2.1-.3.3-.3.5zm-2.1-9c0 .2.2.3.4.3s.3-.3.3-.5-.3-.3-.5-.3-.3.2-.2.5zm-1.3 21.1c0 .2.3.3.5.3s.3-.3.3-.5-.2-.3-.4-.3c-.3.1-.5.3-.4.5zm-1.8-9.1c0 .2.2.3.5.3.2 0 .3-.2.3-.4s-.2-.3-.5-.3c-.2 0-.4.2-.3.4zm-1.8-9.1c0 .2.2.3.5.3.2 0 .3-.2.3-.4s-.2-.3-.4-.3c-.3 0-.4.2-.4.4zm-1.8-9.1c0 .2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3c-.2-.1-.3.1-.3.4zm-12.1 13c0 .2.1.4.3.4.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.3.1-.5.2-.5.4zm1.8-9.1c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.2-.1-.4.1-.5.3zm1.8-9.1c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.5-.1 0-.3.2-.4.4zm29.5 21c.1.2.4.2.5.1.2-.1.2-.4.1-.5-.1-.2-.3-.2-.5-.1-.1.1-.2.3-.1.5zm-5.1-7.7c.1.2.4.2.5.1.2-.1.2-.4.1-.5-.1-.2-.3-.2-.5-.1s-.2.3-.1.5zm-10.3 3.2c.1.1.2.2.4.2.1-.1.2-.2.2-.4-.1-.1-.2-.2-.4-.2-.2.1-.3.2-.2.4zm-2.8-6.5c.1.1.2.2.4.1.1-.1.2-.2.1-.4-.1-.1-.2-.2-.4-.2-.1.2-.1.4-.1.5zm-2.7-6.4c.1.1.2.2.4.1.1-.1.2-.2.1-.4-.1-.1-.2-.2-.4-.1-.1.1-.2.2-.1.4zm-9.4 12.2c0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.1 0-.3.1-.3.3zm0-7.1c0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.2.1-.3.2-.3.3zm-.1-7c0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.2.1-.3.2-.3.3zm-1.6-1.4c0 .1.1.1.2.1s.1-.1.1-.2-.1-.1-.2-.1c-.1.1-.1.1-.1.2zm4.5 6.2c.1.1.2.2.4.1.1-.1.2-.2.1-.3-.1-.1-.2-.2-.3-.1-.3 0-.3.2-.2.3zm-3.4-5.4c.1.1.2.2.3.1.1-.1.2-.2.1-.3-.1-.1-.2-.2-.4-.1 0 0-.1.2 0 .3zm-3.4-5.3c.1.1.2.2.4.1.1-.1.2-.2.1-.4-.1-.1-.2-.2-.4-.1-.1.1-.1.2-.1.4z",
              },
            }),
            _c("path", {
              staticClass: "st31",
              attrs: {
                id: "L_hand-i2",
                d: "M-82.1 37.2s55.8-1.7 65-5c9.2-3.3 23.4-10.8 27.9-7.6 4.5 3.1 20.1 16.7 20.1 16.7s-3.8 4.2-12.1-1-8.5-6.8-13-3.5C1.3 40-11.6 49.4-19.7 46.6c-8.1-2.8-12.5-1.9-19.8 3-7.3 4.9-45.2 23.7-45.2 23.7l2.6-36.1",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "sweater-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "4138.089",
                  y1: "-2062.833",
                  x2: "4363.179",
                  y2: "-3444.882",
                  gradientTransform:
                    "matrix(.08862 0 0 -.08892 -524.44 -207.5)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#sweater-i2_1_)" },
              attrs: {
                id: "sweater-i2",
                d: "m-88.4-41.2-17.4-17.5c-11.6 1.5-22.8 5-33.2 10.4-5.7 3-11.2 6.4-16.4 10.2-23.8 17.5-23.9 27.8-37.3 38.4 0 0-.1 0-.1.1-13.4 10.6-31 23.1-25.1 47.5 5.9 3.5 11.6 6.6 17 9.4 17.8 9 32.8 14.2 45.2 16.9 7.5 1.7 15.1 2.6 22.8 2.6 6 0 12.1-.8 17.9-2.5 2.3-.7 4.5-1.6 6.6-2.6 6-.8 11.9-2.2 17.6-4.1-30.7-45.5 2.4-108.8 2.4-108.8z",
              },
            }),
            _c("path", {
              staticClass: "st3",
              attrs: {
                id: "R_sleeve-i2",
                d: "M-88.4-41.2s-37.2 23.4-28.7 56c2.5 9.5 8.6 14.3 19.9 17.8 13.5 4.3 17 4.1 17 4.1l-3.7 61s-28.3.5-40.6-13.2c-13.9-15.4-25.1-17.3-33.6-23.3-12.8-9.1-16.2-24.5-15.3-42.3 1.6-33.6 26.1-66.4 67.6-77.6",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "neck-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "4705.502",
                  y1: "-1929.451",
                  x2: "4924.288",
                  y2: "-1630.061",
                  gradientTransform:
                    "matrix(.08862 0 0 -.08892 -524.44 -207.5)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#neck-i2_1_)" },
              attrs: {
                id: "neck-i2",
                d: "M-72.9-66.2s-7.5 8.5-15.5 24.9c0 0-14.3 3.3-17.4-17.5 0 0 15.1-6.8 15.6-14.2l17.3 6.8z",
              },
            }),
            _c("path", {
              staticClass: "st31",
              attrs: {
                id: "face-i2",
                d: "M-52.7-87.2v2.1c-.3 6.2 3.2 11.7 2.9 13.4-.3 1.7-3.8 2.2-5.4 2.1s-4.9 7.3-12.1 10.7c-6.7 3.1-15.6 1-20.9-3.3 0-13.4 2.1-22.5 15.7-26.1 14.9-3.9 16.9-9.7 16.9-9.7 1.8 3.2 2.8 6.9 2.9 10.8z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "hair-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "4760.164",
                  y1: "-709.407",
                  x2: "4981.903",
                  y2: "-1179.363",
                  gradientTransform:
                    "matrix(.08862 0 0 -.08892 -524.44 -207.5)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#e94766" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#d62648" },
                  attrs: { offset: ".992" },
                }),
              ],
              1
            ),
            _c("circle", {
              staticStyle: { fill: "url(#hair-i2_1_)" },
              attrs: { id: "hair-i2", cx: "-95.2", cy: "-128.7", r: "13.2" },
            }),
            _c("path", {
              staticClass: "st3",
              attrs: {
                id: "eyeglasses-i2",
                d: "M-43.6-80.5c1.3-3.4.4-7.2-1.8-8.4-2.3-1.2-5.1.6-6.4 4-.1.4-.3.8-.4 1.2-1.5-.4-3 .3-4.3 1.3 0-.2 0-.4-.1-.6-.2-1.6-1.2-3.1-2.6-4-2.6-1.4-5.9.7-7.4 4.7-.7 1.9-.9 3.9-.5 5.8.2 1.3.9 2.5 1.8 3.4.2.2.5.4.8.5 1.3.7 3 .6 4.2-.3 1.5-1.1 2.6-2.6 3.2-4.3.5-1.3.7-2.7.7-4.1 1.2-.9 2.7-1.8 4.1-1.4-.3 2.4.3 4.6 1.7 5.8.2.2.4.3.7.5 2.2 1.2 5-.7 6.3-4.1zm-17.1 6.7c-1 .7-2.3.9-3.5.3-1.2-.7-2-1.9-2.1-3.3-.3-1.7-.2-3.5.4-5.1 1.3-3.5 4.1-5.4 6.3-4.2.2.1.4.3.6.4.8.8 1.3 1.8 1.5 2.9.3 1.7.2 3.5-.4 5.1-.4 1.6-1.4 3-2.8 3.9zm11-3.6c-1.9-1-2.5-4.2-1.4-7.1 1.1-2.9 3.5-4.5 5.3-3.5 1.9 1 2.5 4.2 1.4 7.1-1 2.9-3.4 4.5-5.3 3.5z",
              },
            }),
            _c("path", {
              staticClass: "st18",
              attrs: {
                id: "hair-2-i2",
                d: "M-79.6-118.5c-8.1-1.6-14.4-.2-19 2.5-5.5-.3-10.1-4.5-10.8-10-.1-.5-.9-.3-.8.2.8 5.4 5.1 9.7 10.5 10.6-3.1 2.1-5.5 4.9-7.2 8.2-.4.5-.7 1-1.1 1.5-3.2 4.8-6.3 8.4-11.5 11.1-6.9 3.5-15.9 6.8-16 16 0 .2.2.4.4.4s.4-.2.4-.4c.1-11.2 13.6-12.8 20.6-18.3 1.8-1.5 3.4-3.3 4.7-5.3-2.1 4.1-5.2 8.9-10.6 10.8-10.2 3.6-12 15.7-12 15.7 17.7 16.9 49.6 17.7 49.6 17.7 6.7-14.5-1.3-21.5 10.9-27.3 13.9-6.5 15.8-13 15.8-13 1.8 3.5 2.8 7.4 2.9 11.3 6.1-20-11.7-28.6-26.8-31.7z",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }